import ChartBase from "./ChartBase";
import Chart from 'chart.js';
import { colors } from "./theme";
export class GateChart extends ChartBase {
    constructor() {
        super();
        this._init = () => {
            // always call this
            this._getElements();
            // primary
            this.primaryCategoryElement = this.wrapper.querySelector("[data-primary-category]");
            this.valueElement = this.wrapper.querySelector("[data-value]");
        };
        this.updateData = (props) => {
            // get correct props
            var correctProps = props;
            // test combined props
            if (props.chartData) {
                correctProps = props.chartData;
            }
            // set metric and question
            this._setBaseInfo(props);
            // get data and labels
            let { data, rawData, labels, backgroundColors } = correctProps;
            if (data.length === 0) {
                this.wrapper.classList.add('dashboard-charts-item-empty');
                return;
            }
            this.rawData = rawData;
            // background colors
            if (!backgroundColors || backgroundColors.length <= 0) {
                backgroundColors = [colors.primary, colors.primaryLight];
            }
            // reverse
            if (this.reversed) {
                data = [...data.reverse()];
                rawData = [...rawData.reverse()];
                labels = [...labels.reverse()];
                backgroundColors = backgroundColors.reverse();
            }
            // set primary value
            this.value = (this.reversed ? data[1] : data[0]) + "%";
            // update data if chart instance exist
            if (this.chart) {
                this.chart.data.datasets[0].data = data;
                // render
                this.chart.update();
            }
            // initiate chart instance
            else {
                const options = {
                    cutoutPercentage: 55,
                    legend: {
                        display: false
                    },
                    animation: {
                    //onProgress: function (animation) {
                    //    const value = animation.animationObject.currentStep / animation.animationObject.numSteps;
                    //    console.log(value);
                    //}
                    },
                    maintainAspectRatio: false,
                    // generate custom legend html
                    legendCallback: (chart) => {
                        if (this.noLegend)
                            return '';
                        var legendHtml = [];
                        var metaData = this.reversedLegend ? [...chart.getDatasetMeta(0).data.reverse()] : chart.getDatasetMeta(0).data;
                        var data = chart.data.datasets[0].data;
                        for (var i = 0; i < data.length; i++) {
                            const dataId = this.reversedLegend ? data.length - 1 - i : i;
                            // create legend item
                            const div = document.createElement("div");
                            div.className = "legend-item";
                            div.setAttribute("data-id", dataId.toString());
                            // check if data is hidden
                            if (metaData[i].hidden == true) {
                                div.classList.add("hidden");
                            }
                            // create legend
                            const spanLegend = document.createElement("span");
                            spanLegend.className = "legend-item-color";
                            spanLegend.style.backgroundColor = metaData[i]._model.backgroundColor;
                            // create legend text
                            const spanText = document.createElement("span");
                            spanText.className = "legend-item-text";
                            spanText.textContent = metaData[i]._model.label;
                            // add to legend item
                            div.appendChild(spanLegend);
                            div.appendChild(spanText);
                            legendHtml.push(div.outerHTML);
                        }
                        return legendHtml.join("");
                    },
                    tooltips: {
                        callbacks: {
                            label: (tooltipItem, data) => {
                                // show raw data out of total
                                var label = data.labels[tooltipItem.index] || '';
                                if (label) {
                                    label = label.toUpperCase() + ':';
                                }
                                if (this.rawData) {
                                    const total = rawData.reduce(function (a, b) {
                                        return a + b;
                                    }, 0);
                                    label += ` ${this.rawData[tooltipItem.index]}/${total}`;
                                }
                                else {
                                    // default
                                    label += ` ${tooltipItem.value}`;
                                }
                                //console.log(tooltipItem);
                                //console.log(this.rawData);
                                //console.log(tooltipItem.index);
                                //console.log(this.rawData[tooltipItem.index]);
                                return label;
                            }
                        }
                    }
                };
                if (this.circle) {
                }
                else {
                    options['rotation'] = Math.PI;
                    options['circumference'] = Math.PI;
                }
                // set primary category
                this.primaryCategory = this.reversed ? labels[1] : labels[0];
                this.chart = new Chart(this.ctx, {
                    type: 'pie',
                    data: {
                        datasets: [{
                                data: data,
                                backgroundColor: backgroundColors
                            }],
                        // These labels appear in the legend and in the tooltips when hovering different arcs
                        labels: labels
                    },
                    options
                });
                // generate legend
                if (!this.noLegend) {
                    this.legendElement.innerHTML = this.chart.generateLegend();
                }
                // add legend filter event
                if (!this.noLegend) {
                    const legends = [].slice.call(this.legendElement.querySelectorAll(".legend-item"));
                    legends.forEach(legendItem => {
                        legendItem.addEventListener("click", () => {
                            const dataIndex = legendItem.getAttribute("data-id");
                            this._filterLegend(dataIndex);
                            // set status
                            legendItem.classList.toggle("hidden", metaData[dataIndex].hidden);
                        });
                    });
                }
                // external event
                this.addEventListener('legend-filter', (e) => {
                    var _a, _b;
                    const dataIndex = e.detail;
                    this._filterLegend(dataIndex);
                    (_b = (_a = this.legendElement) === null || _a === void 0 ? void 0 : _a.querySelector(`data-id=[${dataIndex}]`)) === null || _b === void 0 ? void 0 : _b.classList.toggle("hidden", metaData[dataIndex].hidden);
                });
            }
            // remove loading
            this.loading = false;
        };
        this._filterLegend = (dataIndex) => {
            const metaData = this.chart.getDatasetMeta(0).data;
            metaData[dataIndex].hidden = !metaData[dataIndex].hidden;
            // render
            this.chart.update();
        };
    }
    get reversed() {
        return this.hasAttribute('reversed');
    }
    get reversedLegend() {
        return this.hasAttribute('reversed-legend');
    }
    set primaryCategory(value) {
        if (this.primaryCategoryElement) {
            this.primaryCategoryElement.textContent = value;
        }
    }
    set value(value) {
        if (this.valueElement) {
            this.valueElement.textContent = value;
        }
    }
    get circle() {
        return this.hasAttribute('circle');
    }
    get noLegend() {
        return this.hasAttribute('no-legend');
    }
    connectedCallback() {
        // html template
        this.innerHTML = `
            <div class="${this.class} dashboard-charts-item" data-wrapper>
                <div class="d-flex align-items-center mb-3">
                    <h6 class="text-uppercase font-weight-bold mb-0" data-metric></h6>
                    ${!!this.chartName ? `<div class="dashboard-charts-name">${this.chartName}</div>` : ''}
                </div>
                <p class="text-muted-light font-italic dashboard-charts-item-question" data-question></p>
                <div class="dashboard-charts-graph">
                    <div class="value-wrapper ${this.circle ? "value-wrapper-center" : ""}">
                        <div class="value-wrapper-label" data-value></div>
                        <div data-primary-category></div>
                    </div>
                    <canvas />
                </div>
                ${!this.noLegend ? `
                <div class="dashboard-charts-legend" data-legend>&nbsp; &nbsp;</div>` : ''}
                <div class="empty-message">No data collected</div>
            </div>
        `;
        this._init();
    }
}
window.customElements.define("sva-gate-chart", GateChart);
